"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdSDKStateActions = exports.AdSDKListeners = void 0;
var AdSDKListeners;
(function (AdSDKListeners) {
    AdSDKListeners["AD_SDK_CLIENT_STATE_UPDATE"] = "ad_sdk_state_update";
    AdSDKListeners["AD_SDK_INTERNAL_STATE_UPDATE"] = "ad_sdk_internal_update";
    AdSDKListeners["ADTECH_PANEL_TOGGLE"] = "adtech_panel_toggle";
    AdSDKListeners["ROTATE_WALLPAPER"] = "ad_sdk_rotate_wallpaper";
})(AdSDKListeners = exports.AdSDKListeners || (exports.AdSDKListeners = {}));
var AdSDKStateActions;
(function (AdSDKStateActions) {
    AdSDKStateActions["UPDATE_CLIENT_STATE"] = "update_client_state";
    AdSDKStateActions["UPDATE_INTERNAL_STATE"] = "update_internal_state";
    AdSDKStateActions["ADTECH_PANEL_TOGGLE"] = "adtech_panel_toggle";
})(AdSDKStateActions = exports.AdSDKStateActions || (exports.AdSDKStateActions = {}));
//# sourceMappingURL=state.js.map